var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, EventEmitter, Input, Output, } from '@angular/core';
import { RowModel } from '@synisys/idm-dynamic-layout-interpreter';
import { DynamicLayout } from '../dynamic-layout';
var RowComponent = /** @class */ (function () {
    function RowComponent() {
        this.rowVisibility = new EventEmitter();
    }
    RowComponent_1 = RowComponent;
    RowComponent.cellColumnCountStyle = function (cellModel) {
        return cellModel.properties.columnCount
            ? ' mdl-cell--'.concat(cellModel.properties.columnCount.m.toString(), '-col mdl-cell--', cellModel.properties.columnCount.s.toString(), '-col-tablet mdl-cell--', cellModel.properties.columnCount.xs.toString(), '-col-phone ')
            : ' mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--4-col-phone ';
    };
    Object.defineProperty(RowComponent.prototype, "styleBlock", {
        get: function () {
            return this._styleBlock;
        },
        set: function (value) {
            this._styleBlock = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowComponent.prototype, "cellsVisibility", {
        get: function () {
            return this._cellsVisibility;
        },
        enumerable: true,
        configurable: true
    });
    RowComponent.prototype.computeCellClass = function (template) {
        return !(template === 'card') ? this._computedCellClassName : '';
    };
    RowComponent.prototype.setCellVisibility = function (index, visibility) {
        this._cellsVisibility[index] = visibility;
        this.rowVisibility.emit(visibility || this._cellsVisibility.indexOf(true) !== -1);
    };
    RowComponent.prototype.ngOnInit = function () {
        this.cells = this.rowModel.cells;
        this._cellsVisibility = this.cells.map(function () { return true; });
        this._computedCellClassName = "sis-" + this._styleBlock + "-grid__column";
    };
    RowComponent.prototype.ngOnDestroy = function () {
    };
    RowComponent.prototype.isCellVisible = function (cellModel) {
        return cellModel.properties.visibility
            ? cellModel.properties.visibility.predicate
                ? cellModel.properties.visibility.predicate(this.layout.getPredicateContext())
                : true
            : true;
    };
    RowComponent.prototype.getCellStyle = function (cellModel) {
        var template = cellModel.properties.template.toLowerCase() === 'card'
            ? 'sis__card'
            : ' ';
        return 'mdl-cell '.concat(template, RowComponent_1.cellColumnCountStyle(cellModel), cellModel.properties.style.has('classes')
            ? cellModel.properties.style.get('classes').join(' ')
            : '');
    };
    RowComponent.prototype.trackByFunc = function (index, cell) {
        return cell.id;
    };
    __decorate([
        Input(),
        __metadata("design:type", RowModel)
    ], RowComponent.prototype, "rowModel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], RowComponent.prototype, "tabId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", DynamicLayout)
    ], RowComponent.prototype, "layout", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], RowComponent.prototype, "rowVisibility", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], RowComponent.prototype, "styleBlock", null);
    RowComponent = RowComponent_1 = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'row',
            template: require('./row.component.html'),
        })
    ], RowComponent);
    return RowComponent;
    var RowComponent_1;
}());
export { RowComponent };
//# sourceMappingURL=row.component.js.map